export const SET_USA = "SET_USA";
export const SET_INTERNATIONAL = "SET_INTERNATIONAL";
export const SET_GEOGRAPHY_STATE = "SET_GEOGRAPHY_STATE";
